import type { SalesTrendSettings } from './types';

export const DEFAULT_SALES_TREND_SETTINGS: SalesTrendSettings = { scope: 'mine' };

export function decodeSalesTrendSettings(value: unknown): SalesTrendSettings {
  if (
    value &&
    typeof value === 'object' &&
    'scope' in value &&
    (value.scope === 'mine' || value.scope === 'branch' || value.scope === 'all')
  ) {
    return { scope: value.scope };
  }
  return DEFAULT_SALES_TREND_SETTINGS;
}
